import qs from 'qs';

const PollTemplates = {
    namespaced: true,

    state: {
        pollTemplatesData: [],
    },

    getters: {
        pollTemplatesData(state) {
            return state.pollTemplatesData;
        },
    },

    mutations: {

        /**
         * Установить значение объекта
         * @param state
         * @param items
         */
        setArr(state, { items }) {
            state['pollTemplatesData'] = items;
        },

        /**
         * Обновить значение элемента объекта
         * @param state
         * @param item
         * @param index
         */
        setItem(state, { item, index }) {
            state['pollTemplatesData'][index] = item;
        },

        /**
         * Добавить значение элемента объекта
         * @param state
         * @param item
         */
        addItem(state, { item }) {
            state['pollTemplatesData'].push(item);
        },

        /**
         * Удалить элемент из объекта
         * @param state
         * @param item
         */
        remove(state, { item }) {
            state['pollTemplatesData'] = state['pollTemplatesData'].filter(iItem => iItem !== item);
        },
    },


    actions: {

        /**
         * Получение данных по уровням
         * @param commit
         * @param dispatch
         * @param getters
         * @param rootGetters
         * @returns {Promise<any>}
         */
        getPollTemplatesData({ commit, dispatch, getters, rootGetters }) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, { root: true });
                axios({
                    url: rootGetters.rootUrl + 'list/index',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.pollTemplates,
                    }),
                }).then(response => (
                    commit('setArr', {
                        items: response.data
                    }),
                    dispatch('loading/isLoading', false, { root: true }),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по анкетам получены.'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, { root: true }),
                        console.log('ERROR IN pollTemplates.js | getPollTemplatesData : ' + err);
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка в получении данных по анкетам!'),
                        reject(err);
                });
            })
        },

        /**
         * Сохранение данных по уровням
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        savePollTemplatesData({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, { root: true });
                const str = JSON.stringify(data.data);
                axios({
                    url: rootGetters.rootUrl + 'list/save',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.pollTemplates,
                    }),
                }).then(response => {
                    console.log(response.data);
                    // Если редактирование
                    if (data.index !== -1) {
                        commit('setItem', {
                            item: data.data,
                            index: data.index
                        });
                        dispatch('loading/isLoading', false, { root: true });
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Данные по анкетам отредактированы!');

                        // Если сохранение нового
                    } else {
                        data.data.pollTemplatesId = response.data[0].pollTemplatesId;
                        commit('addItem', {
                            item: data.data
                        });
                        dispatch('loading/isLoading', false, { root: true });
                        window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Новая анкета успешно создан!');
                    }
                    resolve();
                }).catch(err => {
                    dispatch('loading/isLoading', false, { root: true });
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при сохранении данных!');
                    console.log('ERROR IN pollTemplates.js | savePollTemplatesData : ' + err);
                    reject(err);
                });
            })
        },

        /**
         * Удаление уровня
         * @param commit
         * @param data
         * @returns {Promise<any>}
         */
        removePollTemplatesData({ commit, dispatch, getters, rootGetters }, data) {
            return new Promise((resolve, reject) => {
                dispatch('loading/isLoading', true, { root: true });
                const str = JSON.stringify(data.item);
                axios({
                    url: rootGetters.rootUrl + 'list/delete',
                    method: 'POST',
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    data: qs.stringify({
                        'data': str,
                        'token': this.getters['auth/getToken'],
                        'service': rootGetters.service.pollTemplates,
                    }),
                }).then(response => (
                    commit('remove', {
                        item: data.item
                    }),
                    dispatch('loading/isLoading', false, { root: true }),
                    window.getApp.$emit('APP_DATA_RECIEVE_SUCCESS', 'Анкеты успешно удалены!'),
                    resolve()
                )).catch(err => {
                    dispatch('loading/isLoading', false, { root: true });
                    window.getApp.$emit('APP_DATA_RECIEVE_ERROR', 'Ошибка при удалении анкеты!'),
                        console.log('ERROR IN pollTemplates.js | removePollTemplatesData : ' + err);
                    reject(err);
                });
            })
        },
    },
};

export default PollTemplates;





// WEBPACK FOOTER //
// ./src/store/modules/pollTemplates.js